<div class="verify-email-container">
  @if (loading) {
    <div>
      <span class="spinner-border spinner-border-sm mr-1"></span>
      {{ 'auth.verifying' | t }}
    </div>
  }

  @if (!loading && success) {
    <div class="alert alert-success">
      <h2>{{ 'auth.verifiedTitle' | t }}</h2>
      <p>{{ 'auth.verifiedText' | t }}</p>
      <button class="btn btn-primary" (click)="openLogin()">{{ 'auth.loginButton' | t }}</button>
    </div>
  }

  @if (!loading && error) {
    <div class="alert alert-danger">
      <h2>{{ 'auth.invalidLink' | t }}</h2>
      <p>{{error}}</p>
    </div>
  }
</div>
